module.exports = __webpack_public_path__ + "img/homepage.67845534.png";